import { createFileRoute, redirect } from '@tanstack/react-router';

// Legacy URL: this page was `/bulk` until it grew a single-person search and
// stopped being about bulk. Kept so bookmarks and links don't hit Not Found.
export const Route = createFileRoute('/_auth/bulk')({
  beforeLoad: () => {
    throw redirect({ to: '/operations' });
  },
});
